import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import ScrollToTop from "@/components/ScrollToTop";
import ThemeManager from "@/components/ThemeManager";
import { PublicSiteProvider } from "@/contexts/PublicSiteContext";

// Public pages
import VCardPage from "@/pages/VCardPage";
import Layout from "@/components/Layout";
import PlanPageRouter from "@/components/PlanPageRouter";

// Admin pages
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import GestionArticles from "@/pages/admin/GestionArticles";
import GestionTemoignages from "@/pages/admin/GestionTemoignages";
import GestionFAQ from "@/pages/admin/GestionFAQ";
import GestionPages from "@/pages/admin/GestionPages";
import ArborescenceV2 from "@/pages/admin/ArborescenceV2";
import GestionMedia from "@/pages/admin/GestionMedia";
import GestionMessagerie from "@/pages/admin/GestionMessagerie";
import GestionVCard from "@/pages/admin/GestionVCard";
import GestionUtilisateurs from "@/pages/admin/GestionUtilisateurs";
import Parametres from "@/pages/admin/Parametres";
import GestionThemes from "@/pages/admin/GestionThemes";
import GestionTarifs from "@/pages/admin/GestionTarifs";
import AProposLogiciel from "@/pages/admin/AProposLogiciel";
import GestionBlocs from "@/pages/admin/GestionBlocs";
import { People, Person } from "@/pages/admin/Activity";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-bone-light flex items-center justify-center"><div className="w-8 h-8 border-2 border-sage border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ThemeManager />
        <BrowserRouter>
          <ScrollToTop />
          <Toaster richColors position="top-right" />
          <Routes>
            {/* Public routes */}
            <Route element={<PublicSiteProvider><Layout /></PublicSiteProvider>}>
              <Route path="*" element={<PlanPageRouter />} />
            </Route>
            <Route path="/vCard/:slug" element={<VCardPage />} />
            {/* Admin routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<GestionArticles />} />
              <Route path="temoignages" element={<GestionTemoignages />} />
              <Route path="faq" element={<GestionFAQ />} />
              <Route path="arborescence" element={<GestionPages />} />
              <Route path="plans" element={<ArborescenceV2 />} />
              <Route path="pages" element={<Navigate to="/admin/arborescence" replace />} />
              <Route path="arborescence-v2" element={<Navigate to="/admin/plans" replace />} />
              <Route path="media" element={<GestionMedia />} />
              <Route path="messagerie" element={<GestionMessagerie />} />
              <Route path="vCard" element={<GestionVCard />} />
              <Route path="themes" element={<GestionThemes />} />
              <Route path="utilisateurs" element={<GestionUtilisateurs />} />
              <Route path="parametres" element={<Parametres />} />
              <Route path="personnes" element={<People />} />
              <Route path="personnes/:id" element={<Person />} />
              <Route path="tarifs" element={<GestionTarifs />} />
              <Route path="a-propos" element={<AProposLogiciel />} />
              <Route path="blocs" element={<GestionBlocs />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
